import { Action } from 'redux-actions';
import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { getTechnicalInterventionRequest } from '../../api/Workflow/getTechnicalInterventionQuery';
import { executeSagaRequest } from '../../services';

import { GetTechnicalInterventionByFileIdPayload } from './actionCreators';
import * as types from './actionTypes';

function* getTechnicalInterventionsByFileIdWorker({
  payload,
}: {
  payload: GetTechnicalInterventionByFileIdPayload;
}): Generator {
  const { fileId } = payload;

  yield executeSagaRequest(
    types.GET_TECHNICAL_INTERVENTIONS_BY_FILE_ID,
    getTechnicalInterventionRequest({ fileId }),
    { indexer: fileId, fileId },
  );

  yield put(types.GET_TECHNICAL_INTERVENTIONS_BY_FILE_ID.end());
}
function* getTechnicalInterventionsByFileIdWatcher() {
  yield takeEvery<Action<GetTechnicalInterventionByFileIdPayload>>(
    types.GET_TECHNICAL_INTERVENTIONS_BY_FILE_ID.BASE,
    getTechnicalInterventionsByFileIdWorker,
  );
}

export default function* main(): Generator {
  try {
    yield all([getTechnicalInterventionsByFileIdWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
